import { createSketchWallGeometryContext } from '../../plugin-sdk/sketch_wall_geometry.js';

export const SKETCH_WALL_TEMPLATES = Object.freeze({
  L: Object.freeze([1300, 2000]), U: Object.freeze([1300, 2000, 1300])
});

// Transform in screen/world x/z axes: mirror is always left/right as displayed.
export function transformSketchWallTemplates(matrix, action) {
  const [a, b, c, d] = matrix;
  return action === 'mirror' ? [-a, -b, c, d] : [-c, -d, a, b];
}

/** Ordinary wall topology, with physical inside lengths including corner miters. */
export function buildSketchWallTemplate(kind, lengths, defaults, matrix = [1, 0, 0, 1], origin = { x: 0, z: 0 }) {
  const count = SKETCH_WALL_TEMPLATES[kind]?.length;
  const thickness = Number(defaults.thickness);
  if (!count || lengths.length !== count || lengths.some(n => !Number.isFinite(n) || n < 20)
    || !Number.isFinite(thickness) || thickness <= 0) return null;
  const half = thickness / 2;
  const points = [{ x: 0, z: -lengths[0] - half }, { x: 0, z: 0 },
    { x: lengths[1] + (kind === 'U' ? thickness : half), z: 0 }];
  if (kind === 'U') points.push({ x: points[2].x, z: -lengths[2] - half });
  const [a, b, c, d] = matrix;
  const nodes = points.map((p, i) => ({ id: `template-node-${i}`, x: origin.x + a * p.x + b * p.z, z: origin.z + c * p.x + d * p.z }));
  // Reverse after reflection so +1 remains the physical inner face.
  const reversed = a * d - b * c > 0;
  const walls = lengths.map((_, i) => ({ ...defaults, id: `template-wall-${i}`,
    startNodeId: nodes[reversed ? i + 1 : i].id, endNodeId: nodes[reversed ? i : i + 1].id }));
  const graph = { nodes, walls, angles: [], straightJoints: [] };
  const geometry = createSketchWallGeometryContext(graph);
  return { ...graph, polygons: walls.map(wall => geometry.corners(wall)), lengths };
}
